import { render } from "./CorporateView.vue?vue&type=template&id=45c7b90e&scoped=true"
import script from "./CorporateView.vue?vue&type=script&lang=js"
export * from "./CorporateView.vue?vue&type=script&lang=js"

import "./CorporateView.vue?vue&type=style&index=0&id=45c7b90e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c7b90e"]])

export default __exports__